import type { HtmlHTMLAttributes } from "react";

interface ButtonIconProps extends HtmlHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  spin?: boolean;
}

export default function ButtonIconSvg({
  className,
  icon,
  spin,
  ...res
}: ButtonIconProps) {
  return (
    <button
      {...res}
      className={`${className} w-11 cursor-pointer duration-150 hover:scale-110 hover:bg-current/10! p-2.5 flex-center text-2xl! h-11 rounded-full`}
    >
      {/* <Icon
        icon={icon}
        className={`${
          spin ? "animate-spin [animation-duration:12s]" : ""
        } text-current!`}
      /> */}
      <div
        className={`${
          spin ? "animate-spin [animation-duration:12s]" : ""
        } text-current!`}
      >
        {icon}
      </div>
    </button>
  );
}
